module.exports = __webpack_public_path__ + "media/images/Fav-100eadb5d127770a863c8ff3ab1327cb.svg";